import { Component, Input } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: 'app-summary-order-logo',
  templateUrl: './summary-order-logo.component.html',
  styleUrls: ['./summary-order-logo.component.css']
})
export class SummaryOrderLogo {
    
    @Input() initialLoading = true;
    @Input() ubicacionFotoLogoTitulo = '';

    constructor(private sanitizer: DomSanitizer) {}

    getLogo() {
        const text = this.ubicacionFotoLogoTitulo.replace(/\\/g, '/');

        return `url("${text}")`;
      }

}